import {
  useTranslation
} from "../../../../chunk-6N4NEKWU.mjs";
import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/ClarifyingQuestions/ClarifyingQuestionsTimelineItem.tsx
import { useRef, useState } from "react";
import { Spinner, Text } from "../../../primitive/index.mjs";
import { useUnfold } from "../shared/unfold.mjs";
import { ShimmerText } from "../ShimmerText/index.mjs";
import { ClarifyingQuestions } from "./ClarifyingQuestions.mjs";
import { ClarifyingQuestionsHeader } from "./ClarifyingQuestionsHeader.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
function ClarifyingQuestionsTimelineItem({ questions, total, turnFailed = false, onComplete, dashboardMode = false }) {
  const { t } = useTranslation();
  const [completed, setCompleted] = useState(false);
  const isReadOnly = dashboardMode || questions.some((q) => q.isSkipped === true || q.answer != null);
  const isLoadingMore = total != null && total > 0 && questions.length < total && !turnFailed;
  const isFullyLoading = isLoadingMore && questions.length === 0;
  const cardRef = useRef(null);
  useUnfold(cardRef, isFullyLoading);
  if (isFullyLoading) {
    return /* @__PURE__ */ jsx("div", { ref: cardRef, className: "buyscout-timeline-clarifying-questions buyscout-timeline-clarifying-questions--loading", children: /* @__PURE__ */ jsxs("div", { className: "buyscout-clarifying buyscout-clarifying--loading", children: [
      /* @__PURE__ */ jsx(ClarifyingQuestionsHeader, {}),
      /* @__PURE__ */ jsxs("div", { className: "buyscout-clarifying-loading", role: "status", children: [
        /* @__PURE__ */ jsx(ShimmerText, { children: /* @__PURE__ */ jsx(Text, { variant: "body", as: "span", className: "buyscout-clarifying-loading-text", children: t("clarifyingQuestions.loadingQuestions") }) }),
        /* @__PURE__ */ jsx(Spinner, { size: "sm", tone: "current", "aria-hidden": true })
      ] })
    ] }) });
  }
  if (!questions || questions.length === 0) return null;
  const handleComplete = (answers) => {
    setCompleted(true);
    onComplete?.(answers);
  };
  const wrapperClass = [
    "buyscout-timeline-clarifying-questions",
    completed ? "buyscout-timeline-clarifying-questions--completed" : isReadOnly ? "buyscout-timeline-clarifying-questions--readonly" : ""
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx("div", { ref: cardRef, className: wrapperClass, children: /* @__PURE__ */ jsx(
    ClarifyingQuestions,
    {
      questions,
      onComplete: handleComplete,
      total,
      turnFailed,
      dashboardMode
    }
  ) });
}
export {
  ClarifyingQuestionsTimelineItem
};
//# sourceMappingURL=ClarifyingQuestionsTimelineItem.mjs.map